module.exports = __webpack_public_path__ + "img/img-sms.adce67bd.png";